import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHeading } from "@/components/ui-bits";

export default function FaqSection({ faqs = [], eyebrow = "FAQ", title = "Frequently Asked Questions", subtitle, emitSchema = true }) {
  if (!faqs.length) return null;
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question", name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
  return (
    <section className="section-pad bg-white" data-testid="faq-section">
      <div className="container-x max-w-3xl">
        {emitSchema && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />}
        <SectionHeading center eyebrow={eyebrow} title={title} subtitle={subtitle} />
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border border-slate-200 rounded-xl mb-3 px-5 data-[state=open]:border-brand data-[state=open]:bg-brand-light/40">
              <AccordionTrigger className="text-left font-heading font-semibold text-navy-heading hover:no-underline py-4" data-testid={`faq-q-${i}`}>{f.q}</AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-4">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
